import { ReactNode } from "react"
import { ThemeProvider } from "@/components/theme/ThemeProvider"

interface AuthLayoutProps {
  children: ReactNode
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  return <ThemeProvider>{children}</ThemeProvider>
}
